export default {
  global: {
    canteenList: [],
    eateryList: [],
    machineList: []
  },
  sideBarFold: false,
  userinfo: {
    api_key: '',
    username: '',
    userGroup: 0
  },
  modelList: [],
  dishModel: {},
  dataMark: {},
  filterWrapper: {
    listQuery: {
      datetimeRange: [new Date(), new Date()],
      dateRange: [new Date(new Date().getTime() - 3600 * 1000 * 24 * 7), new Date()],
      datetime: new Date(),
      machine: {},
      canteen: {},
      eatery: {}
    }
  },
  admin: {
    loginMessage: {
      type: '',
      message: ''
    }
  },
  login: {
    loginForm: {
      username: '',
      password: ''
    }
  },
  fullscreenLoading: false,
  batchList: [],
  markImageList: [],
  currentDishModelIndex: 0,
  markedCount: {},
  allClassList: [],
  batchTag: '',
  uncheckedDishList: [],
  subtitle: '',
  unMarkedImageList: [],
  markedImageList: [],
  checkTextObjList: [],
  subMenuShow: true,
  allCanteenList: [],
  taskFormData: {},
  detectedUnCheckList: [],
  backDataUnCheckList: [],
  dataCollectCheckRemindList: [],
  allImageList: [],
  taskUuid: '',
  // 暂存
  currentCheckTaskInfo: {},
  downLoadImageList: [],
  showTest: false,
  cachedDishList: [],
  activeTable: '',
  checkingTaskUUID: '',
  taskUUIDForTrain: [
    [], []
  ],
  checkRegionData: [],
  premarkData: [],
  label_task_id: '',
  allMachineList: [],
  customMachineList: [],
  api_version_list: [],
  category_list: []
};
